// import { useParams, useNavigate } from "react-router-dom";
// import { ArrowLeft, Mail, Users, Eye, MousePointer, Calendar, MapPin, Tag } from "lucide-react";
// import { Button } from "@/components/ui/button";
// import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
// import { Badge } from "@/components/ui/badge";
// import { Separator } from "@/components/ui/separator";
// import { Sidebar } from "@/components/Sidebar";

// const CampaignView = () => {
//   const { id } = useParams();
//   const navigate = useNavigate();

//   // Mock campaign data - replace with actual data fetching
//   const campaign = {
//     id: id,
//     name: "Spring Open House Campaign",
//     date: "2024-03-15",
//     type: "Property",
//     status: "sent",
//     recipients: 1234,
//     opens: 567,
//     clicks: 234,
//     openRate: 45.9,
//     clickRate: 19.0,
//     template: "Template 1",
//     property: "123 Main Street, Cityville, ST 12345",
//     databases: ["Database A", "Database B", "Database C"],
//     subject: "Join us for an Exclusive Spring Open House Event",
//     message: "We're excited to invite you to our upcoming open house event. This beautiful property features modern amenities and is located in a prime neighborhood. Don't miss this opportunity to view this stunning home!"
//   };

//   const getStatusBadge = (status: string) => {
//     const variants: Record<string, "default" | "secondary" | "destructive" | "outline"> = {
//       sent: "default",
//       draft: "secondary",
//       scheduled: "outline",
//     };
//     return <Badge variant={variants[status] || "default"}>{status}</Badge>;
//   };

//   return (
//     <div className="flex h-screen bg-background">
//       <Sidebar />
//       <div className="flex-1 overflow-auto">
//         <div className="container mx-auto p-6 max-w-6xl">
//           <div className="flex items-center justify-between mb-6">
//             <div className="flex items-center gap-4">
//               <Button
//                 variant="outline"
//                 size="icon"
//                 onClick={() => navigate("/campaigns")}
//               >
//                 <ArrowLeft className="h-4 w-4" />
//               </Button>
//               <div>
//                 <h1 className="text-3xl font-bold text-primary">Campaign Details</h1>
//                 <p className="text-muted-foreground">View campaign information and performance</p>
//               </div>
//             </div>
//             <Button onClick={() => navigate(`/campaigns/edit/${id}`)}>
//               Edit Campaign
//             </Button>
//           </div>

//           <div className="space-y-6">
//             {/* Campaign Header */}
//             <Card>
//               <CardHeader>
//                 <div className="flex items-start justify-between">
//                   <div>
//                     <CardTitle className="text-2xl mb-2">{campaign.name}</CardTitle>
//                     <div className="flex items-center gap-4 text-sm text-muted-foreground">
//                       <div className="flex items-center gap-1">
//                         <Calendar className="h-4 w-4" />
//                         {campaign.date}
//                       </div>
//                       <div className="flex items-center gap-1">
//                         <Tag className="h-4 w-4" />
//                         {campaign.type}
//                       </div>
//                       {getStatusBadge(campaign.status)}
//                     </div>
//                   </div>
//                 </div>
//               </CardHeader>
//             </Card>

//             {/* Performance Metrics */}
//             <div className="grid grid-cols-1 md:grid-cols-4 gap-4">
//               <Card>
//                 <CardHeader className="pb-3">
//                   <CardTitle className="text-sm font-medium text-muted-foreground">
//                     Recipients
//                   </CardTitle>
//                 </CardHeader>
//                 <CardContent>
//                   <div className="flex items-center gap-2">
//                     <Users className="h-5 w-5 text-primary" />
//                     <span className="text-2xl font-bold">{campaign.recipients.toLocaleString()}</span>
//                   </div>
//                 </CardContent>
//               </Card>

//               <Card>
//                 <CardHeader className="pb-3">
//                   <CardTitle className="text-sm font-medium text-muted-foreground">
//                     Opens
//                   </CardTitle>
//                 </CardHeader>
//                 <CardContent>
//                   <div className="flex items-center gap-2">
//                     <Eye className="h-5 w-5 text-primary" />
//                     <span className="text-2xl font-bold">{campaign.opens}</span>
//                   </div>
//                   <p className="text-sm text-muted-foreground mt-1">{campaign.openRate}% open rate</p>
//                 </CardContent>
//               </Card>

//               <Card>
//                 <CardHeader className="pb-3">
//                   <CardTitle className="text-sm font-medium text-muted-foreground">
//                     Clicks
//                   </CardTitle>
//                 </CardHeader>
//                 <CardContent>
//                   <div className="flex items-center gap-2">
//                     <MousePointer className="h-5 w-5 text-primary" />
//                     <span className="text-2xl font-bold">{campaign.clicks}</span>
//                   </div>
//                   <p className="text-sm text-muted-foreground mt-1">{campaign.clickRate}% click rate</p>
//                 </CardContent>
//               </Card>

//               <Card>
//                 <CardHeader className="pb-3">
//                   <CardTitle className="text-sm font-medium text-muted-foreground">
//                     Template
//                   </CardTitle>
//                 </CardHeader>
//                 <CardContent>
//                   <div className="flex items-center gap-2">
//                     <Mail className="h-5 w-5 text-primary" />
//                     <span className="text-lg font-semibold">{campaign.template}</span>
//                   </div>
//                 </CardContent>
//               </Card>
//             </div>

//             {/* Campaign Content */}
//             <Card>
//               <CardHeader>
//                 <CardTitle>Campaign Content</CardTitle>
//               </CardHeader>
//               <CardContent className="space-y-4">
//                 <div>
//                   <h3 className="font-semibold text-sm text-muted-foreground mb-1">Subject Line</h3>
//                   <p className="text-base">{campaign.subject}</p>
//                 </div>
//                 <Separator />
//                 <div>
//                   <h3 className="font-semibold text-sm text-muted-foreground mb-1">Message</h3>
//                   <p className="text-base">{campaign.message}</p>
//                 </div>
//               </CardContent>
//             </Card>

//             {/* Property & Targeting */}
//             <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
//               <Card>
//                 <CardHeader>
//                   <CardTitle>Property Information</CardTitle>
//                 </CardHeader>
//                 <CardContent>
//                   <div className="flex items-start gap-2">
//                     <MapPin className="h-5 w-5 text-primary mt-0.5" />
//                     <p className="text-base">{campaign.property}</p>
//                   </div>
//                 </CardContent>
//               </Card>

//               <Card>
//                 <CardHeader>
//                   <CardTitle>Target Databases</CardTitle>
//                 </CardHeader>
//                 <CardContent>
//                   <div className="space-y-2">
//                     {campaign.databases.map((db, index) => (
//                       <div key={index} className="flex items-center gap-2">
//                         <Badge variant="outline">{db}</Badge>
//                       </div>
//                     ))}
//                   </div>
//                 </CardContent>
//               </Card>
//             </div>
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default CampaignView;

// src/pages/CampaignView.tsx
// src/pages/CampaignView.tsx
import React, { useEffect, useState } from "react";
import { useParams, useNavigate, useLocation } from "react-router-dom";
import { Helmet } from "react-helmet-async";
import axiosInstance from "@/config/axiosInstance";
import { endpoints } from "@/config/apiEndpoints";

import {
  ArrowLeft,
  Mail,
  Users,
  Eye,
  MousePointer,
  Calendar,
  MapPin,
  Tag,
  Info,
  TrendingUp,
  MessageSquare,
  Database,
  Target,
  Send,
  Clock,
  CheckCircle2,
  XCircle,
  AlertCircle,
  Home,
  Building2,
} from "lucide-react";

import { Button } from "@/components/ui/button";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
import { Separator } from "@/components/ui/separator";
import { Sidebar } from "@/components/Sidebar";
import { useTimezone } from '@/contexts/TimezoneContext';
import { PageHeader } from "@/components/Header";
import { Skeleton } from "@/components/ui/skeleton";

const CampaignView = () => {
  const { id } = useParams<{ id: string }>();
  const navigate = useNavigate();
  const location = useLocation();

  const [campaign, setCampaign] = useState<any>(null);
  const [stateName, setStateName] = useState("—");
  const [cityName, setCityName] = useState("—");
  const [databases, setDatabases] = useState<{ name: string; count: number }[]>([]);
  const { formatDateTime, timezone } = useTimezone();
  const [error, setError] = useState(false);
  const [loading, setLoading] = useState(true);

  const refreshTrigger = location.state?.refresh || location.state?.refreshedAt;

  useEffect(() => {
    const fetchAll = async () => {
      if (!id) return;

      try {
        setLoading(true);
        setError(false);

        let url = endpoints.getCampaignById(id);
        let resp;
        try {
          resp = await axiosInstance.get(url);
        } catch (e: any) {
          if (e.response?.status === 404) {
            url = `${endpoints.listCampaigns}?property_id=${id}`;
            resp = await axiosInstance.get(url);
          } else throw e;
        }

        const data = resp.data?.campaign || resp.data?.[0] || resp.data;
        setCampaign(data);

        if (data?.state_id) {
          try {
            const stateUrl = `${endpoints.db_states}${data.state_id}/`;
            const stateResp = await axiosInstance.get(stateUrl);
            setStateName(stateResp.data?.state_name || `State ID: ${data.state_id}`);
          } catch {
            setStateName(`State ID: ${data.state_id}`);
          }
        }

        if (data?.city_id?.[0]) {
          try {
            const cityUrl = `${endpoints.db_cities}${data.city_id[0]}/`;
            const cityResp = await axiosInstance.get(cityUrl);
            setCityName(cityResp.data?.city_name || `City ID: ${data.city_id[0]}`);
          } catch {
            setCityName(`City ID: ${data.city_id[0]}`);
          }
        }

        if (data?.city_id && Array.isArray(data.city_id)) {
          const dbPromises = data.city_id.map(async (dbId: number) => {
            try {
              const dbUrl = `${endpoints.db_cities}${dbId}/`;
              const dbResp = await axiosInstance.get(dbUrl);
              return {
                name: dbResp.data?.city_name || `Database ${dbId}`,
                count: dbResp.data?.agent_count || 0,
              };
            } catch {
              return { name: `Database ${dbId}`, count: 0 };
            }
          });
          const resolved = await Promise.all(dbPromises);
          setDatabases(resolved);
        } else if (data?.databases && Array.isArray(data.databases)) {
          setDatabases(data.databases.map((name: string) => ({ name, count: 0 })));
        }
      } catch (err) {
        console.error("Failed to load campaign:", err);
        setError(true);
      } finally {
        setLoading(false);
      }
    };

    fetchAll();
  }, [id, refreshTrigger]);

  const getStatusConfig = (status: string) => {
    const s = status?.toLowerCase();
    switch (s) {
      case "running": case "sent":
        return { badge: "bg-green-100 text-green-800 border-green-300", icon: CheckCircle2, color: "from-green-500 to-green-600", iconBg: "bg-green-100", iconColor: "text-green-600" };
      case "scheduled":
        return { badge: "bg-purple-100 text-purple-800 border-purple-300", icon: Calendar, color: "from-purple-500 to-purple-600", iconBg: "bg-purple-100", iconColor: "text-purple-600" };
      case "pending":
        return { badge: "bg-yellow-100 text-yellow-800 border-yellow-300", icon: Clock, color: "from-yellow-500 to-yellow-600", iconBg: "bg-yellow-100", iconColor: "text-yellow-600" };
      case "failed": case "error":
        return { badge: "bg-red-100 text-red-800 border-red-300", icon: XCircle, color: "from-red-500 to-red-600", iconBg: "bg-red-100", iconColor: "text-red-600" };
      default:
        return { badge: "bg-gray-100 text-gray-800 border-gray-300", icon: AlertCircle, color: "from-gray-500 to-gray-600", iconBg: "bg-gray-100", iconColor: "text-gray-600" };
    }
  };

  if (error) {
    return (
      <div className="flex min-h-screen bg-white">
        <Sidebar />
        <div className="flex-1 flex items-center justify-center">
          <div className="text-center space-y-6">
            <XCircle className="h-20 w-20 text-red-500 mx-auto" />
            <div>
              <p className="text-2xl font-bold text-gray-900">Launch Not Found</p>
              <p className="text-gray-500 mt-2">The launch you're looking for doesn't exist or has been removed.</p>
            </div>
            <Button onClick={() => navigate("/launches")} size="lg">
              <ArrowLeft className="h-5 w-5 mr-2" />
              Back to Launch Management
            </Button>
          </div>
        </div>
      </div>
    );
  }

  if (loading || !campaign) {
    return (
      <div className="flex min-h-screen bg-white">
        <Sidebar />
        <main className="flex-1 flex flex-col">
          <PageHeader pageTitle="Launch Details" />
          <div className="flex-1 p-6 lg:p-8">
            <div className="max-w-7xl mx-auto space-y-6">
              <Skeleton className="h-40 rounded-2xl" />
              <div className="grid grid-cols-1 md:grid-cols-4 gap-6">
                {[1, 2, 3, 4].map(i => <Skeleton key={i} className="h-36 rounded-2xl" />)}
              </div>
              <Skeleton className="h-80 rounded-2xl" />
            </div>
          </div>
        </main>
      </div>
    );
  }

  const statusConfig = getStatusConfig(campaign.status);
  const StatusIcon = statusConfig.icon;

  const recipients = campaign.recipients_count || 0;
  const openCount = campaign.open_count ?? Math.round(((campaign.openrate || 0) > 100 ? (campaign.openrate / 10) : (campaign.openrate || 0)) / 100 * recipients);
  const clickCount = campaign.click_count ?? Math.round(((campaign.clickrate || 0) > 100 ? (campaign.clickrate / 10) : (campaign.clickrate || 0)) / 100 * recipients);
  const openRate = campaign.openrate ? (campaign.openrate > 100 ? campaign.openrate / 10 : campaign.openrate).toFixed(1) : 0;
  const clickRate = campaign.clickrate ? (campaign.clickrate > 100 ? campaign.clickrate / 10 : campaign.clickrate).toFixed(1) : 0;

  const performanceStats = [
    { title: "Recipients", value: recipients.toLocaleString(), icon: Users, color: "from-blue-500 to-blue-600", iconBg: "bg-blue-100", iconColor: "text-blue-600" },
    {
      title: "Opens",
      value: openCount.toLocaleString(),
      subtitle: `${openRate}% Open Rate`,
      icon: Eye,
      color: "from-emerald-500 to-emerald-600",
      iconBg: "bg-emerald-100",
      iconColor: "text-emerald-600",
      tooltipTitle: "Open Rate",
      tooltipDescription: "Percentage of delivered emails opened by recipients.",
      tooltipFormula: "(Emails Opened ÷ Emails Delivered) × 100",
    },
    {
      title: "Clicks",
      value: clickCount.toLocaleString(),
      subtitle: `${clickRate}% Click Rate`,
      icon: MousePointer,
      color: "from-purple-500 to-purple-600",
      iconBg: "bg-purple-100",
      iconColor: "text-purple-600",
      tooltipTitle: "Click Rate",
      tooltipDescription: "Percentage of delivered emails where a recipient clicked a link.",
      tooltipFormula: "(Unique Clicks ÷ Emails Delivered) × 100",
    },
    { title: "Engagement", value: recipients > 0 ? ((clickCount / recipients) * 100).toFixed(1) + "%" : "0%", subtitle: "Click-Through Rate", icon: TrendingUp, color: "from-pink-500 to-pink-600", iconBg: "bg-pink-100", iconColor: "text-pink-600" },
  ];

  const campaignTitle = campaign.campaign_name?.trim()
    || (campaign.campaign_type?.toLowerCase() === "service" ? campaign.service_type : campaign.property_title)
    || "Untitled Launch";

  return (
    <>
      <Helmet>
        <title>{campaign?.campaign_name || campaign?.campaign_subject || "Campaign"} | MyListIQ</title>
        <meta name="description" content={`${campaign?.campaign_name || "Campaign"} - ${campaign?.recipient_count || 0} recipients`} />

        {/* Open Graph Meta Tags for Social Sharing */}
        <meta property="og:title" content={campaign?.campaign_name || campaign?.campaign_subject || "MyListIQ Campaign"} />
        <meta property="og:description" content={`Launch: ${campaign?.campaign_name || "Campaign"} - Status: ${campaign?.status} - Recipients: ${campaign?.recipient_count || 0}`} />
        <meta property="og:type" content="website" />
        <meta property="og:url" content={window.location.href} />
        {campaign?.image_url && <meta property="og:image" content={campaign.image_url} />}
        {campaign?.thumbnail_url && <meta property="og:image" content={campaign.thumbnail_url} />}

        {/* Twitter Card Meta Tags */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content={campaign?.campaign_name || "MyListIQ Campaign"} />
        <meta name="twitter:description" content={`${campaign?.campaign_name || "Campaign"} - Status: ${campaign?.status}`} />
        {campaign?.image_url && <meta name="twitter:image" content={campaign.image_url} />}
        {campaign?.thumbnail_url && <meta name="twitter:image" content={campaign.thumbnail_url} />}
      </Helmet>

      <div className="flex min-h-screen bg-white">
        <Sidebar />

        <main className="flex-1 flex flex-col">
          <PageHeader pageTitle="Launch Details" />

          <div className="flex-1 p-4 sm:p-6 lg:p-8 overflow-y-auto">
            <div className="max-w-7xl mx-auto space-y-6">

              {/* Back Button Row */}
              <div className="flex items-center justify-between">
                <Button
                  variant="ghost"
                  size="sm"
                  onClick={() => navigate("/launches")}
                  className="text-gray-600 hover:text-gray-900 gap-2"
                >
                  <ArrowLeft className="h-4 w-4" />
                  Back to Launches
                </Button>

              </div>

              {/* Hero Header Card */}
              <Card className="border-0 shadow-lg overflow-hidden">
                <div className={`h-2 bg-gradient-to-r ${statusConfig.color}`} />
                <CardContent className="p-6 lg:p-8">
                  <div className="flex flex-col lg:flex-row items-start lg:items-center justify-between gap-6">
                    <div className="flex items-start gap-5">
                      <div className={`p-4 rounded-2xl ${statusConfig.iconBg}`}>
                        <StatusIcon className={`h-9 w-9 ${statusConfig.iconColor}`} />
                      </div>
                      <div>
                        <h2 className="text-3xl font-bold text-gray-900 mb-3">
                          {campaignTitle}
                        </h2>
                        <div className="flex flex-wrap items-center gap-4 text-sm text-gray-600">
                          <div className="flex items-center gap-2">
                            <Calendar className="h-4 w-4" />
                            {formatDateTime(campaign.scheduled_date || campaign.date)}
                            <span className="text-xs text-gray-400">
                              ({timezone || "UTC"})
                            </span>
                          </div>
                          <Badge
                            variant="outline"
                            className={
                              campaign.campaign_type?.toLowerCase() === "service"
                                ? "border-purple-300 bg-purple-50 text-purple-700"
                                : "border-blue-300 bg-blue-50 text-blue-700"
                            }
                          >
                            {campaign.campaign_type === "service" ? "Service" : campaign.campaign_type ? campaign.campaign_type.charAt(0).toUpperCase() + campaign.campaign_type.slice(1).toLowerCase() : "Property"}
                          </Badge>
                        </div>
                      </div>
                    </div>

                    <Badge className={`${statusConfig.badge} border font-semibold text-sm px-5 py-2`}>
                      {campaign.status ? campaign.status.charAt(0).toUpperCase() + campaign.status.slice(1).toLowerCase() : "Unknown"}
                    </Badge>
                  </div>
                </CardContent>
              </Card>

              {/* Performance Stats Grid */}
              <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
                {performanceStats.map((stat, i) => (
                  <Card
                    key={i}
                    className="relative border-0 shadow-lg overflow-visible hover:shadow-xl transition-all duration-300 hover:-translate-y-1"
                  >
                    <CardHeader className="flex flex-row items-center justify-between pb-2">
                      <div className="flex items-center gap-2">
                        <CardTitle className="text-sm font-medium text-gray-600">
                          {stat.title}
                        </CardTitle>
                        {stat.tooltipTitle && (
                          <div className="relative inline-flex group">
                            <span className="h-7 w-7 rounded-full bg-slate-100 text-slate-600 inline-flex items-center justify-center text-sm font-semibold">
                              <Info className="h-4 w-4" />
                            </span>
                            <div className="pointer-events-none absolute right-0 bottom-full mb-2 w-72 rounded-2xl border border-slate-200 bg-white p-3 text-left text-xs text-slate-700 shadow-xl opacity-0 group-hover:opacity-100 transition-opacity duration-200 z-50">
                              <p className="font-semibold text-slate-900">{stat.tooltipTitle}</p>
                              <p className="text-slate-600 mt-1">{stat.tooltipDescription}</p>
                              <p className="mt-3 font-medium text-slate-900">Formula:</p>
                              <p className="text-slate-600">{stat.tooltipFormula}</p>
                            </div>
                          </div>
                        )}
                      </div>
                      <div className={`p-3 rounded-xl ${stat.iconBg}`}>
                        <stat.icon className={`h-5 w-5 ${stat.iconColor}`} />
                      </div>
                    </CardHeader>
                    <CardContent>
                      <div className="text-3xl font-bold text-gray-900">
                        {stat.value}
                      </div>
                      {stat.subtitle && (
                        <p className="text-xs text-gray-500 mt-1">{stat.subtitle}</p>
                      )}
                    </CardContent>
                    <div className={`absolute bottom-0 left-0 right-0 h-1 bg-gradient-to-r ${stat.color}`} />
                  </Card>
                ))}
              </div>

              {/* Content + Targeting Grid */}
              {/* Content + Targeting Grid */}
              <div className="grid grid-cols-1 lg:grid-cols-2 gap-6 items-stretch">

                {/* LEFT COLUMN */}
                <div className="flex flex-col gap-6 h-full">

                  {/* Launch Content */}
                  <Card className="border-0 shadow-lg flex flex-col">
                    <CardHeader className="border-b">
                      <div className="flex items-center gap-3">
                        <div className="p-3 bg-blue-100 rounded-xl">
                          <Mail className="h-6 w-6 text-blue-600" />
                        </div>
                        <CardTitle className="text-xl font-bold">Launch Content</CardTitle>
                      </div>
                    </CardHeader>

                    <CardContent className="p-6 space-y-6 flex-1">
                      <div>
                        <h3 className="text-sm font-semibold text-gray-700 mb-3">
                          Subject Line
                        </h3>
                        <div className="bg-amber-50 border border-amber-200 rounded-xl p-4">
                          <p className="font-medium text-amber-900">
                            {campaign.campaign_subject || "No subject provided"}
                          </p>
                        </div>
                      </div>

                      <Separator />

                      <div className="flex items-center justify-between">
                        <span className="text-sm font-semibold text-gray-700">
                          Template Used
                        </span>
                        <Badge variant="secondary">
                          {campaign.template || "Custom"}
                        </Badge>
                      </div>
                    </CardContent>
                  </Card>

                  {/* Targeted Reach */}
                  <Card className="border-0 shadow-lg flex flex-col">
                    <CardHeader className="border-b">
                      <div className="flex items-center gap-3">
                        <div className="p-3 bg-purple-100 rounded-xl">
                          <Target className="h-6 w-6 text-purple-600" />
                        </div>
                        <CardTitle className="text-xl font-bold">Targeted Reach</CardTitle>
                      </div>
                    </CardHeader>

                    <CardContent className="p-6 space-y-5 flex-1">
                      {/* <div className="bg-blue-50 border border-blue-200 rounded-xl p-4">
                        <p className="text-xs font-bold text-blue-600 uppercase mb-1">
                          State
                        </p>
                        <p className="text-xl font-bold text-blue-900">{stateName}</p>
                      </div> */}

                      <div className="bg-gradient-to-r from-emerald-50 to-blue-50 border rounded-xl p-4">
                        <div className="flex items-center justify-between">
                          <span className="font-semibold text-gray-700">Total Reach</span>
                          <span className="text-2xl font-bold text-emerald-600">
                            {recipients}
                          </span>
                        </div>
                      </div>
                    </CardContent>
                  </Card>

                </div>

                {/* RIGHT COLUMN */}
                <div className="flex flex-col gap-6 h-full">

                  {/* Property Details */}
                  <Card className="border-0 shadow-lg flex flex-col flex-1">
                    <CardHeader className="border-b">
                      <div className="flex items-center gap-3">
                        <div className="p-3 bg-emerald-100 rounded-xl">
                          <Home className="h-6 w-6 text-emerald-600" />
                        </div>
                        <CardTitle className="text-xl font-bold">Property Details</CardTitle>
                      </div>
                    </CardHeader>

                    <CardContent className="p-6 space-y-5 flex-1">
                      <div className="bg-blue-50 border border-blue-200 rounded-xl p-4">
                        <p className="text-xs font-bold text-blue-600 uppercase mb-1">
                          Property Title
                        </p>
                        <p className="text-lg font-bold text-blue-900">
                          {campaign.property_title}
                        </p>
                      </div>

                      <div className="grid grid-cols-2 gap-3">
                        <div className="bg-green-50 border border-green-200 rounded-xl p-4">
                          <p className="text-xs font-bold text-green-600 uppercase mb-1">
                            Launch Type
                          </p>
                          <p className="text-sm font-semibold text-green-900">
                            {campaign.property_type || "Property"}
                          </p>
                        </div>

                        {/* <div className="bg-gray-50 border border-gray-200 rounded-xl p-4">
          <p className="text-xs font-bold uppercase mb-1 text-gray-600">
            Open House
          </p>
          <div className="flex items-center gap-2">
            {campaign.is_open_house ? (
              <>
                <CheckCircle2 className="h-4 w-4 text-orange-600" />
                <span className="text-sm font-semibold text-orange-900">Yes</span>
              </>
            ) : (
              <>
                <XCircle className="h-4 w-4 text-gray-400" />
                <span className="text-sm font-semibold text-gray-600">No</span>
              </>
            )}
          </div>
        </div> */}
                      </div>
                    </CardContent>
                  </Card>

                </div>

              </div>


            </div>
          </div>
        </main>
      </div>
    </>
  );
};

export default CampaignView;